class EnableTransitions {
	constructor() {
		this.init()
	}

	init() {
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				setTimeout(() => {
					document.body.classList.remove('preload')
				}, 100)
			})
		})
	}
}

new EnableTransitions()

window.EnableTransitions = EnableTransitions
